// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__FqXtE","overflowing":"ReadFullNote_overflowing__2gn-M"};